import { put, takeLatest } from "redux-saga/effects";
import { getTalkDetails, getTalkSheet } from "src/redux/actions";
import { mapError } from "../../../../helpers/error";
import { mapSessionDatePayload, mapTalkSheetPayload } from "../../helpers";
import { IGetTalkSheetAction } from "../../types";
import { SagaIterator } from "@redux-saga/core";
import { IQuestionnaire } from "src/common/types";

type FetchTalkSheet = SagaIterator | Promise<IQuestionnaire>;

function* fetchTalkSheet({ payload: { talkId, lng } }: IGetTalkSheetAction): FetchTalkSheet {
  try {
    const talk = yield getTalkDetails(talkId);
    const talkSheet = yield getTalkSheet(talkId, lng);

    const talkSheetValues = mapTalkSheetPayload(talkSheet);
    const sessionDateValues = mapSessionDatePayload(talk);

    yield put({
      payload: {
        sessionDateValues,
        talk,
        talkSheet,
        talkSheetValues
      },
      type: "GET_TALK_SHEET_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line: no-console
    console.error(e);
    yield put({
      payload: {
        e: mapError(e)
      },
      type: "GET_TALK_SHEET_REJECTED"
    });
  }
}

export default function* talkSheetWatcher() {
  yield takeLatest("GET_TALK_SHEET", fetchTalkSheet);
  yield takeLatest("REFETCH_TALK_SHEET", fetchTalkSheet);
}
